import { render, staticRenderFns } from "./CompareData.vue?vue&type=template&id=dbdb9d40&scoped=true&"
import script from "./CompareData.vue?vue&type=script&lang=js&"
export * from "./CompareData.vue?vue&type=script&lang=js&"
import style0 from "./CompareData.vue?vue&type=style&index=0&id=dbdb9d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdb9d40",
  null
  
)

export default component.exports